<template>
    <article class="page-cabinet-dashboard-actives">
        <div class="page-cabinet-dashboard-actives__headline">
            <div class="page-cabinet-dashboard-actives__headline-title">
                Активы
            </div>
        </div>
        <div class="page-cabinet-dashboard-actives__graph">
            <ui-card-base with-border>
                <div class="page-cabinet-dashboard-actives__graph-container">
                    <div class="page-cabinet-dashboard-actives__graph-legend" v-if="items.length">
                        <div class="page-cabinet-dashboard-actives__graph-legend-item _header">
                            <div>Объекты</div>
                            <div></div>
                            <div>Количество акций</div>
                            <div>Текущая стоимость</div>
                        </div>
                        <div
                            class="page-cabinet-dashboard-actives__graph-legend-item"
                            v-for="item in slicedItems"
                            :key="item.title"
                        >
                            <div class="page-cabinet-dashboard-actives__graph-legend-item-image">
                                <common-image v-bind:image="item.image" v-bind:href="item.url" />
                            </div>
                            <div>{{item.title}}</div>
                            <div>{{item.quantity}}&nbsp;шт.</div>
                            <div>{{item.currentValueFormatted}}</div>
                        </div>

                        <div
                            class="page-cabinet-dashboard-actives__graph-legend-pagination"
                            v-if="items.length > perPage"
                        >
                            <page-cabinet-pagination
                                v-bind:current-page="page"
                                v-bind:total-items="items.length"
                                v-bind:per-page="perPage"
                                v-on:change-page="(num) => page = num"
                            />
                        </div>
                    </div>
                </div>
            </ui-card-base>

            <div class="page-cabinet-dashboard-actives__graph-back-forward">
                <page-cabinet-back-forward
                    v-bind:has-prev-button="page > 1"
                    v-bind:has-next-button="hasNextPage"
                    v-on:on-back="page > 1 ? --page : page = 1"
                    v-on:on-forward="page++"
                />
            </div>

            <transition name="fade">
                <div class="page-cabinet-dashboard-actives__graph-loader"
                    v-if="getUserSharesIsLoading"
                    >
                    <ui-loader
                        v-bind:fixed="50"
                        v-bind:centered="true"
                    />
                </div>
            </transition>
        </div>
    </article>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'page-cabinet-dashboard-actives',
    props: {
        items: {
            type: Array,
            default: null,
        },
    },
    data: function() {
        return {
            page: 1,
        };
    },
    computed: {
        ...mapState('dashboard', [
            'getUserSharesIsLoading',
        ]),
        perPage() {
            return this.isSmallScreen ? 5 : 3;
        },
        startIndex() {
            return (this.page - 1) * this.perPage;
        },
        hasNextPage() {
            return this.startIndex + this.perPage < this.items.length;
        },
        slicedItems() {
            return this.items?.slice(this.startIndex, this.startIndex + this.perPage) ?? [];
        },
        isSmallScreen() {
            return window.innerWidth < 1023;
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-dashboard-actives {
    margin-bottom: 40px;
    &__headline {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        width: 100%;
        padding: 0 16px;
        &-title {
            .typography-heading();

            flex: 0 0 auto;
            padding-right: 24px;
            padding-bottom: 8px;
        }
    }

    &__graph {
        position: relative;
        height: 240px;
        &-legend {
            display: flex;
            flex-direction: column;
            gap: 8px;
            width: 100%;
        }

        &-legend-item {
            .typography-body();

            display: grid;
            grid-template-columns: 40px 1fr 1fr 1fr;
            align-items: center;
            gap: 16px;
            padding: 0 4px;
            &._header {
                .typography-caption();

                padding-bottom: 4px;
                color: @color-gray-darker;
            }
            &._highlight {
                color: @color-gray-lightest;
                background-color: @color-primary;
                border-radius: 4px;
            }

            &-image {
                flex: 0 0 auto;
                width: 40px;
                height: 40px;
            }
        }

        &-legend-pagination {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            height: 100%;
        }
        @media @media-md-down {
            &-legend-pagination {
                display: none;
            }
        }

        &-container {
            display: flex;
            flex-direction: row;
            gap: 16px;
            width: 100%;
            height: 100%;
        }
        @media @media-md-down {
            &-container {
                flex-direction: column-reverse;
                height: auto;
            }
        }

        &-back-forward {
            display: none;
            margin-top: 16px;
        }
        @media @media-md-down {
            &-back-forward {
                display: block;
            }
        }

        &-loader {
            .transition-fade();

            position: absolute;
            top: 5px;
            right: 5px;
            bottom: 5px;
            left: 5px;
            z-index: 1;

            display: flex;
            align-items: center;
            justify-content: center;

            background-color: fade(@color-gray-lightest, 75%);
        }
    }
    @media @media-md-down {
        &__graph {
            height: auto;
        }
    }
}
</style>
